import React from "react";
import { useTranslation } from "react-i18next";

import { ProjectLocationCustomNotesForm } from "./Form";
import { useMe } from "../../../../../hooks/queries";
import { AccountType } from "../../../../../models/AccountData";
import { ProjectsLocationsData } from "../../../../../models/ProjectData";

import "./styles.scss";

interface IProjectLocationCustomNotesProps {
  organizationId: string;
  projectLocation: ProjectsLocationsData;
}

export const ProjectLocationCustomNotes: React.FC<
  IProjectLocationCustomNotesProps
> = (props) => {
  const { organizationId, projectLocation } = props;
  const { data: me } = useMe();
  const isAdmin = me?.type === AccountType.ADMIN;
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(
      `projectManagementPage.projectFacilityDetailsModal.projectLocationCustomNotes.${key}`,
    );

  return (
    <div className="project-location-custom-notes">
      <div className="project-location-custom-notes-container">
        <h2 className="project-location-custom-notes-title">
          {t("custom_notes")}
        </h2>
        {!!projectLocation && (
          <ProjectLocationCustomNotesForm
            organizationId={organizationId}
            projectLocation={projectLocation}
            allowSubmit={isAdmin}
          />
        )}
      </div>
    </div>
  );
};
